import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import formModel from "../../ProjectWizardPages/formModel";
import ActivityTable from "./ActivityTable";
import VerticalTable from "./VerticalTable";
import { Project } from "../../../types/project";
import { getTranslatedDeviceTypes } from "../../../helpers/utils";

type ReviewSubmitProps = {
  values: Project;
};

export default function ReviewSubmitTable({ values }: ReviewSubmitProps) {
  const { t } = useTranslation();
  const {
    formField: {
      projectName,
      description,
      location,
      deviceType,
      localCoordinatorEmail,
    },
  } = formModel;

  const projectDetails = [
    { label: t(projectName.label), value: values.projectName },
    { label: t(location.label), value: values.location },
    { label: t(description.label), value: values.description },
    {
      label: t(deviceType.label),
      value: getTranslatedDeviceTypes(values.deviceType, t),
    },
    {
      label: t(localCoordinatorEmail.label),
      value:
        values.localCoordinatorEmail === ""
          ? "-"
          : values.localCoordinatorEmail.toLowerCase(),
    },
  ];

  return (
    <Grid
      container
      mt={2}
      sx={{
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          lg: "row",
        },
      }}
    >
      <Grid item xs>
        <Grid container direction="column">
          <Grid container>
            <Grid flexGrow={1} />
            <Grid item xs={12} sm={12} md={8} lg={10}>
              <VerticalTable
                title={t("labels.projectDetails")}
                data={projectDetails}
              />
            </Grid>
            <Grid flexGrow={1} />
          </Grid>
        </Grid>
      </Grid>
      <Divider orientation="vertical" flexItem />
      <Grid item xs>
        <Grid container>
          <Grid flexGrow={1} />
          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            lg={10}
            sx={{ marginTop: { xs: 2, sm: 2, md: 2, lg: 0 } }}
          >
            <ActivityTable />
          </Grid>
          <Grid flexGrow={1} />
        </Grid>
      </Grid>
    </Grid>
  );
}
